import { Component, OnInit } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  catalogueProperties: any = {};

  constructor(private domService: DomService) { }

  ngOnInit() {
    


    this.domService.addClassToBody('bg-gray');
  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
